export function isExternalURL(url: string) {
  return url.startsWith('http://') || url.startsWith('https://');
}
